// src/utils/apiError.ts
import axios from "axios";

type ApiErrorBody = {
  message?: string;
  error?: string;
  detail?: string;
};

export function getApiErrorMessage(err: unknown, fallback = "Something went wrong") {
  if (axios.isAxiosError(err)) {
    const data = err.response?.data as ApiErrorBody | undefined;
    return data?.message || data?.error || err.message || fallback;
  }
  if (err instanceof Error) return err.message;
  return fallback;
}
